import React from "react";

const Loader: React.FC = () => {
  return (
    <div>
      <div id="cover-spin"></div>
    </div>
  );
};

export default Loader;
